// extracted by mini-css-extract-plugin
module.exports = {"review-service-logo":"_2TBHl8XknEWK3PZ7U_fxti"};